<!-- VIEW MODE -->
<div
  class="view-mode-section-title flex justify-between items-center py-lg my-lg">
  <h1 class="">
    {{ 'system_settings_screen_working_info_label' | transloco }}
  </h1>

  <a
    id="system_settings_screen_edit_button'"
    [routerLink]="[
      `/${ADMIN_ROUTES.SYSTEM_SETTINGS.PROFILE}/edit` | tenantPath: 'admin',
    ]"
    class="text-primary-600 font-medium text-base py-sm px-2xl border-none rounded-md gap-sm flex items-center">
    <lib-edit-icon [iconClass]="'size-5 text-primary-600'" />

    {{ 'group_details_screen_edit_button' | transloco }}
  </a>
</div>

<div class="flex mt-lg gap-lg">
  <!-- WORKING DAYS  -->
  <div class="flex flex-col">
    <p class="view-mode-label">
      {{ 'system_settings_screen_working_days_label' | transloco }}
    </p>

    <div class="flex">
      @for (day of workingDays()?.days; track day.name.value) {
        @if (day.is_working) {
          <p class="view-mode-value break-word text-neutral-900">
            {{ day.name.label }} {{ isLastWorkingDay(day) ? '' : ',' }}
          </p>
        }
      }
    </div>
  </div>

  <!-- START DAY  -->
  <div class="flex flex-col items-center flex-grow">
    <div class="flex flex-col">
      <p class="view-mode-label">
        {{ 'edit_system_settings_screen_week_start_on_label' | transloco }}
      </p>
      <p class="view-mode-value break-word text-neutral-900">
        {{ workingDays()?.start_day?.label }}
      </p>
    </div>
  </div>

  <!-- WORKING HOURS   -->
  <div class="flex-grow flex flex-col">
    <p class="view-mode-label">
      {{ 'system_settings_screen_working_hours_label' | transloco }}
    </p>
    <p class="view-mode-value break-word text-neutral-900">
      {{
        workingDays()?.days?.[0]
          ? convertTo12Hour(workingDays()?.days?.[0]?.started_at)
          : ''
      }}
      -
      {{
        workingDays()?.days?.[0]
          ? convertTo12Hour(workingDays()?.days?.[0]?.ended_at)
          : ''
      }}
    </p>
  </div>
</div>
